import { APP_ENV, VERSION } from '@modules/config';
import { mainGray } from '@modules/theme';

interface Props {
    small?: boolean;
}
export default function VersionInfo({ small }: Props) {
    const env = APP_ENV[0].toUpperCase();

    return <p style={small ? SMALL : LARGE}>{`v${VERSION} [${env}]`}</p>;
}

const SMALL = { fontSize: '.6rem', color: mainGray, textAlign: 'center', marginBottom: 0 };
const LARGE = { fontSize: '1rem', color: mainGray };
